import React, { useEffect } from "react";

import { Box, CircularProgress } from "@mui/material";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";

const ImpersonatePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const tokenBase64 = searchParams.get("token") ?? "";
    const token = atob(tokenBase64);
    Cookies.set("token", token, { secure: true });
    navigate("/", { replace: true });
  }, []);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
};

export default ImpersonatePage;
